import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { SettingsStore, Theme, Language } from '@/types/settings';

export const STORAGE_KEY = 'settings-storage';

export const useSettingsStore = create<SettingsStore>()(
  persist(
    (set) => ({
      theme: 'system',
      language: 'en',
      setTheme: (theme: Theme) => set({ theme }),
      setLanguage: (language: Language) => set({ language }),
    }),
    {
      name: STORAGE_KEY,
    },
  ),
);
